export const SIGN_UP = 'SIGN_UP';
export const SIGN_IN = 'SIGN_IN';
export const SET_VIEW = 'SET_VIEW';
export const GET_CURRENT_USER = 'GET_CURRENT_USER';
export const SIGN_OUT = 'SIGN_OUT';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const SIGN_USER_IN = 'SIGN_USER_IN';
export const SIGN_USER_OUT = 'SIGN_USER_OUT';
export const SET_USER_LOADING = 'SET_USER_LOADING';
export const SEND_EMAIL_VERIFICATION_EMAIL = 'SEND_EMAIL_VERIFICATION_EMAIL';
export const SEND_RESET_PASSWORD_EMAIL = 'SEND_PASSWORD_RESET_LINK';
export const CONFIRM_RESET_PASSWORD = 'CONFIRM_RESET_PASSWORD';

// REDUCER ACTIONS
export function signUserIn(user: any) {
  return {
    type: SIGN_USER_IN,
    payload: user,
  };
}

export function signUserOut() {
  return {
    type: SIGN_USER_OUT,
  };
}

export function setView(view: any) {
  return {
    type: SET_VIEW,
    payload: view
  };
}

// SAGA ACTIONS
export function signUp(payload: any, formActions: any) {
  return {
    type: SIGN_UP,
    payload,
    formActions,
  };
}

export function sendResetPasswordEmail(payload: any, formActions: any) {
  return {
    type: SEND_RESET_PASSWORD_EMAIL,
    payload,
    formActions,
  };
}

export function signIn(payload: any, formActions: any) {
  return {
    type: SIGN_IN,
    payload,
    formActions,
  };
}

export function sendEmailVerificationEmail(payload: any, formActions?: any) {
  return {
    type: SEND_EMAIL_VERIFICATION_EMAIL,
    payload,
    formActions,
  };
}

export function confirmResetPassword(payload: any, formActions: any) {
  return {
    type: CONFIRM_RESET_PASSWORD,
    payload,
    formActions,
  };
}

export function setUserLoading(isLoading: any) {
  return {
    type: SET_USER_LOADING,
    payload: isLoading,
  };
}

export function getCurrentUser() {
  return {
    type: GET_CURRENT_USER,
  };
}

export function signOut() {
  return {
    type: SIGN_OUT,
  };
}

export function refreshToken() {
  return {
    type: REFRESH_TOKEN,
  };
}
